import React from 'react';
import ReactDOM from 'react-dom/client';
import {HashRouter} from "react-router-dom";

import { Provider } from 'react-redux'

import store from './data/store'

import './index.css';

import BidibDataProvider from "./components/BidibDataProvider";
import Programmer from "./components/programmer/Programmer";

const root = ReactDOM.createRoot(
    document.getElementById('root')
);

const standalone = true

if( !standalone) {

    root.render(
        <React.StrictMode>
            <Provider store={store}>
                <HashRouter>
                    <BidibDataProvider/>
                </HashRouter>
            </Provider>
        </React.StrictMode>
    );

} else {
    root.render(
        <React.StrictMode>
            <Programmer/>
        </React.StrictMode>
    );

}



